import React from 'react';
import { getBezierPath, useKeyPress } from '@xyflow/react';

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style = {},
  data,
  sourceHandle,
  selected,
}) => {
  const deletePressed = useKeyPress('Backspace');

  React.useEffect(() => {
    if (deletePressed && selected && data?.onDelete) {
      data.onDelete(id);
    }
  }, [deletePressed, selected, id, data]);

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    curvature: 0.25
  });

  const getEdgeColor = () => {
    const baseColor = sourceHandle === 'false' 
      ? '#faad14'
      : sourceHandle === 'true' 
        ? '#52c41a'
        : data?.colorMode === 'dark' ? '#9254de' : '#858585';

    if (selected) {
      if (data?.colorMode === 'dark') {
        return baseColor === '#9254de' ? '#7828d8' : baseColor;
      }
      return baseColor === '#858585' ? '#666666' : baseColor;
    }
    
    return baseColor;
  };

  const handleEdgeDelete = (event, id) => {
    event.stopPropagation();
    if (data?.onDelete) {
      data.onDelete(id);
    }
  };

  const edgeStyle = {
    ...style,
    strokeWidth: selected ? 3 : 2,
    stroke: getEdgeColor(),
    transition: 'stroke-width 0.2s, stroke 0.2s',
  };

  const buttonStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    background: data?.colorMode === 'dark' ? '#141414' : '#fff',
    borderRadius: '50%',
    border: `1px solid ${data?.colorMode === 'dark' ? '#434343' : '#d9d9d9'}`,
    width: '25px',
    height: '25px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: '20px',
    lineHeight: '16px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial',
    color: '#ff4d4f',
    userSelect: 'none',
    transform: 'translateY(0px)', // Fine-tune vertical centering
    paddingBottom: '4px',
  };

  return (
    <>
      <path
        id={id}
        style={edgeStyle}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      <foreignObject
        width={26}
        height={26}
        x={labelX - 12.5}
        y={labelY - 12.5}
        className={`edge-delete-button ${selected ? 'selected' : ''}`}
        requiredExtensions="http://www.w3.org/1999/xhtml"
      >
        <div
          style={buttonStyle}
          onClick={(event) => handleEdgeDelete(event, id)}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = data?.colorMode === 'dark' ? '#1f1f1f' : '#fff1f0';
            e.currentTarget.style.borderColor = '#ff4d4f';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = data?.colorMode === 'dark' ? '#141414' : '#fff';
            e.currentTarget.style.borderColor = data?.colorMode === 'dark' ? '#434343' : '#d9d9d9';
          }}
        >
          ×
        </div>
      </foreignObject>
    </>
  );
};

export default CustomEdge;